import React, { useEffect } from 'react';
import './PrivacyPolicy.css';
import '../PolicyPages.css';

function PrivacyPolicy() {
    useEffect(() => { window.scrollTo(0, 0); }, []);

    return (
        <div className="policy-page">

            {/* Hero */}
            <div className="policy-hero">
                <div className="container">
                    <div className="policy-hero-icon"><i className="fas fa-shield-alt"></i></div>
                    <h1 className="policy-hero-title">Privacy Policy</h1>
                    <p className="policy-hero-sub">Last updated: June 2025</p>
                </div>
            </div>

            {/* Card */}
            <div className="container">
                <div className="policy-card">

                    <p className="policy-intro">
                        At <strong>PENTADECO.IN</strong>, we are committed to safeguarding your privacy.
                        This Privacy Policy explains how we collect, use, and protect your information
                        when you use our website{' '}
                        <a href="https://pentadeco.in" target="_blank" rel="noreferrer">www.pentadeco.in</a>.
                        By accessing or purchasing from our site, you agree to the practices outlined below.
                    </p>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">1</span>
                            <h3 className="policy-section-title">Information We Collect</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Personal Information:</strong> Name, email address, phone number, shipping/billing address, and payment details (securely processed via third-party gateways).</li>
                            <li><strong>Non-Personal Information:</strong> IP address, browser type, device details, and browsing activity for analytics and site improvements.</li>
                            <li><strong>Cookies:</strong> We use cookies to enhance user experience, store preferences, and analyze traffic. You may control cookies via your browser settings.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">2</span>
                            <h3 className="policy-section-title">How We Use Your Information</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Order Fulfillment:</strong> Processing, shipping, and delivering your purchases.</li>
                            <li><strong>Communication:</strong> Sending order updates, responding to inquiries, and providing support. With consent, promotional offers may also be sent.</li>
                            <li><strong>Improvement:</strong> Analyzing data to enhance our services and customer experience.</li>
                            <li><strong>Legal Compliance:</strong> Ensuring obligations under Indian law including the DPDP Act 2023 are met.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">3</span>
                            <h3 className="policy-section-title">Data Sharing</h3>
                        </div>
                        <ul className="policy-list">
                            <li><strong>Logistics &amp; Payment Partners:</strong> To deliver orders and process payments securely.</li>
                            <li><strong>Legal Authorities:</strong> If required by applicable laws or to prevent fraud.</li>
                            <li><strong>Business Transfers:</strong> In case of mergers, acquisitions, or restructuring.</li>
                        </ul>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">4</span>
                            <h3 className="policy-section-title">Your Rights</h3>
                        </div>
                        <p className="policy-text">
                            You have the right to access, update, correct, or delete your personal data.
                            You may also withdraw consent for marketing communications. For requests, email us at{' '}
                            <a href="mailto:pentadeco@gmail.com">pentadeco@gmail.com</a>.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">5</span>
                            <h3 className="policy-section-title">Data Security</h3>
                        </div>
                        <p className="policy-text">
                            We use SSL encryption and industry-standard measures to protect data.
                            However, no method of transmission over the Internet is 100% secure.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">6</span>
                            <h3 className="policy-section-title">Children's Privacy</h3>
                        </div>
                        <p className="policy-text">
                            Our website is intended for users aged 18 and above. We do not knowingly collect data from children
                            under 18. If found, such data will be deleted promptly.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">7</span>
                            <h3 className="policy-section-title">International Data Transfer</h3>
                        </div>
                        <p className="policy-text">
                            Data may be stored or processed outside India (e.g., cloud servers).
                            By using our services, you consent to such transfers in line with Indian law.
                        </p>
                    </div>

                    <div className="policy-section">
                        <div className="policy-section-header">
                            <span className="policy-num">8</span>
                            <h3 className="policy-section-title">Policy Updates</h3>
                        </div>
                        <p className="policy-text">
                            We may revise this Privacy Policy as required. Updates will be posted with a "Last Updated" date.
                        </p>
                    </div>

                    {/* Contact */}
                    <div className="policy-contact-card">
                        <p className="policy-contact-title"><i className="fas fa-headset"></i> Contact Us</p>
                        <div className="policy-contact-row">
                            <i className="fas fa-building"></i>
                            <span>Pentadeco Customer Service</span>
                        </div>
                        <div className="policy-contact-row">
                            <i className="fas fa-envelope"></i>
                            <span><a href="mailto:pentadeco@gmail.com">pentadeco@gmail.com</a></span>
                        </div>
                        <div className="policy-contact-row">
                            <i className="fab fa-whatsapp"></i>
                            <span>
                                <a href="tel:+917738494171">+91 77384 94171</a> &nbsp;|&nbsp;
                                <a href="tel:+918433551012">+91 84335 51012</a> &nbsp;|&nbsp;
                                <a href="tel:+919273158535">+91 92731 58535</a>
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

export default PrivacyPolicy;
